<figure class="cs-pd" *ngIf="layout">
	<figcaption class="cs-pd__title" *ngIf="spec.title">{{ spec.title }}</figcaption>

	<div class="cs-pd__scroll">
		<svg class="cs-pd__svg"
			 [attr.viewBox]="'0 0 ' + layout.width + ' ' + layout.height"
			 [attr.width]="layout.width"
			 [attr.height]="layout.height"
			 (mouseleave)="onLeave()"
			 preserveAspectRatio="xMinYMin meet"
			 xmlns="http://www.w3.org/2000/svg">

			<defs>
				<marker id="cs-pd-arrow" viewBox="0 0 10 10" refX="9" refY="5"
						markerWidth="7" markerHeight="7" orient="auto-start-reverse">
					<path d="M0,0 L10,5 L0,10 z" class="cs-pd__arrowhead"></path>
				</marker>
			</defs>

			<!-- Edges first, so nodes paint over the connector ends -->
			<g class="cs-pd__edges">
				<g *ngFor="let e of layout.edges" class="cs-pd__edge" [class.cs-pd__edge--back]="e.back">
					<path [attr.d]="e.path" class="cs-pd__edge-path" marker-end="url(#cs-pd-arrow)"></path>
					<text *ngIf="e.label" [attr.x]="e.labelX" [attr.y]="e.labelY"
						  class="cs-pd__edge-label" text-anchor="middle" dominant-baseline="middle">{{ e.label }}</text>
				</g>
			</g>

			<!-- Nodes -->
			<g class="cs-pd__nodes">
				<g *ngFor="let n of layout.nodes; trackBy: trackNode"
				   class="cs-pd__node"
				   [class.cs-pd__node--hover]="hovered?.id === n.id"
				   (mouseenter)="onEnter(n, $event)"
				   (mousemove)="onMove($event)">

					<!-- Shape by kind -->
					<polygon *ngIf="n.kind === 'decision'" [attr.points]="n.points"
							 class="cs-pd__shape cs-pd__shape--decision"></polygon>
					<rect *ngIf="n.kind !== 'decision'"
						  [attr.x]="n.x" [attr.y]="n.y" [attr.width]="n.w" [attr.height]="n.h"
						  [attr.rx]="n.kind === 'start' || n.kind === 'end' ? n.h / 2 : 10"
						  class="cs-pd__shape"
						  [class.cs-pd__shape--terminal]="n.kind === 'start' || n.kind === 'end'"></rect>

					<!-- Label + optional metric (HTML for real text wrapping) -->
					<foreignObject [attr.x]="labelBox(n).x" [attr.y]="labelBox(n).y"
								   [attr.width]="labelBox(n).w" [attr.height]="labelBox(n).h">
						<div class="cs-pd__label" xmlns="http://www.w3.org/1999/xhtml">
							<span class="cs-pd__label-text">{{ n.label }}</span>
							<span class="cs-pd__label-metric" *ngIf="n.metric">{{ n.metric }}</span>
						</div>
					</foreignObject>
				</g>
			</g>
		</svg>
	</div>

	<!-- Hover tooltip -->
	<div class="cs-pd__tip" *ngIf="hovered"
		 [style.left.px]="tipX + 14" [style.top.px]="tipY + 14">{{ tooltipText(hovered) }}</div>
</figure>
